import { render, staticRenderFns } from "./TimeSliceLoading.vue?vue&type=template&id=56632164&"
import script from "./TimeSliceLoading.vue?vue&type=script&lang=js&"
export * from "./TimeSliceLoading.vue?vue&type=script&lang=js&"
import style0 from "./TimeSliceLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports